import React from "react";
import { Container } from "reactstrap";
import CommonHeader from "./CommonHeader";
import "../assets/css/argon-dashboard-react.css";
import logo from "../assets/img/logo2.svg";
import { useEffect, useState } from "react";
import { fetchXp, fetchLevel, increaseXp } from "apiHandles/user_progress";
import "../assets/css/StagePage.css"
import { Link } from "react-router-dom";
import "../assets/css/Home.css";
import { subNames } from "../components/translation.js"
import { useDarkMode } from "context/DarkModeProvider";
import "../assets/css/colors.css";
import { useLanguage } from "context/LanguageProvider";

const StagePage = ({ children, title }) => {
  const [xp, setXp] = React.useState(0);
  const [level, setLevel] = React.useState(null);

  const normalize = str => str.replace(/\s+/g, " ").trim();

  const { darkMode } = useDarkMode();

  const { selLanguage, toggleLanguage, isLoading } = useLanguage();

  React.useEffect(() => {
    const getXp = async () => {
      const xp = await fetchXp();
      setXp(xp || 0);
    };
    getXp();
  }, []);

  React.useEffect(() => {
    const getLevel = async () => {
      const level = await fetchLevel();
      setLevel(level || 1);
    };
    getLevel();
  }, []);

  return (
    <div className="container-stage" >
      <CommonHeader />

      <Container className="main-container-stage" style={{
        background: darkMode
          ? '#0f172a'
          : 'var(--lightModeBack)',
      }}>
        <h1 className="title-stage">
          {selLanguage

            ? "Στάδια " + subNames[normalize(title)] : "Stages of " + title}
        </h1>
        <div className="flex-column-center">
          {children}
        </div>
      </Container>
    </div>
  );
};

export default StagePage;